export enum CategoryNames {
  ENVIRONMENT = 'environment'
}